import React from "react";
import { Calendar, Fish, TrendingUp, BarChart3, Droplets, LineChart } from "lucide-react";
import { WQ_CHART_CONFIGS } from "../pondStat/wqChartConfigs";
import { LABEL } from "../../../utils/samplingDisplayLabels";

export const graphTypes = [
  {
    id: "wr-vs-length",
    name: `${LABEL.WR_ASCII} vs Length`,
    description:
      "Shows relative weight distribution across fish lengths with reference line at WR = 1.0",
    icon: <TrendingUp className="w-5 h-5" />,
  },
  {
    id: "weight-vs-length",
    name: "Actual Weight vs Length",
    description:
      "Compares actual weight to standard weight formula across lengths",
    icon: <BarChart3 className="w-5 h-5" />,
  },
  {
    id: "weight-vs-length-by-date",
    name: "Actual Weight vs Length by Sampling Date",
    description:
      "Same as Actual Weight vs Length; point color = sampling session date, shape = species. Gray dashed line = standard weight (Ws).",
    icon: <Calendar className="w-5 h-5" />,
  },
  {
    id: "avg-wr-vs-date",
    name: `Average ${LABEL.WR_ASCII} vs Date`,
    description:
      "Tracks average WR over time with error bars showing standard deviation",
    icon: <Calendar className="w-5 h-5" />,
  },
  {
    id: "tagged-wr-vs-date",
    name: `${LABEL.WR_ASCII} vs Date for Tagged Fish`,
    description:
      "Each tagged fish: individual WR at each sampling date (one line per tag). Use Tags to narrow by tag mode or tag numbers.",
    icon: <Calendar className="w-5 h-5" />,
  },
  {
    id: "standard-vs-actual",
    name: "Standard Weight vs Actual Weight",
    description:
      "1:1 comparison plot with reference line showing ideal weight relationship",
    icon: <Fish className="w-5 h-5" />,
  },
  {
    id: "number-frequency",
    name: `Number Frequency and Average ${LABEL.WR_ASCII} by Bin Size`,
    description:
      "Shows fish count distribution across size bins with average WR and standard deviation",
    icon: <BarChart3 className="w-5 h-5" />,
  },
  {
    id: "number-frequency-vs-bin",
    name: "Percentage of Population vs. Bin Size",
    description:
      "Percentage of the total sample in each length bin (from bin counts).",
    icon: <BarChart3 className="w-5 h-5" />,
  },
  {
    id: "number-frequency-vs-bin-by-date",
    name: "Percentage of Population vs. Bin Size by Sampling Date",
    description:
      "Grouped bars by sampling session; each bar is percent of fish within that session only (same length bins for all dates).",
    icon: <Calendar className="w-5 h-5" />,
  },
  ...WQ_CHART_CONFIGS.map((c) => ({
    id: c.id,
    name: c.title,
    description: "Water quality parameters vs sampling date for the selected pond.",
    icon: <Droplets className="w-5 h-5" />,
  })),
  {
    id: "psd-vs-date",
    name: "Proportional Size Distribution vs Date",
    description:
      "PSD-Q/P/M/T by species over time (denominator: fish ≥ 20 cm or ≥ 8 in by unit system).",
    icon: <LineChart className="w-5 h-5" />,
  },
  {
    id: "population-pct-cumulative-vs-bin",
    name: `${LABEL.PCT_OF_POPULATION} and ${LABEL.CUM_PCT_OF_POPULATION} vs Bin Size`,
    description:
      "Single session: bars = percent of population per bin; line = cumulative percent (select session when multiple dates).",
    icon: <BarChart3 className="w-5 h-5" />,
  },
  {
    id: "population-cumulative-vs-bin-by-date",
    name: `${LABEL.CUM_PCT_OF_POPULATION} vs Bin Size By Date`,
    description: "One line per sampling session showing cumulative length distribution.",
    icon: <Calendar className="w-5 h-5" />,
  },
];
